import { SAMPLE_FORMATTED_TIMESTAMP } from '@cli-constants/generators.js'
export function addFormattedTimestamps(data: Record<string, unknown>): Record<string, unknown> {
  const output = { ...data }

  if (typeof output.createdAt === 'string') {
    output.createdAtFormatted = SAMPLE_FORMATTED_TIMESTAMP
  }

  if (typeof output.updatedAt === 'string') {
    output.updatedAtFormatted = SAMPLE_FORMATTED_TIMESTAMP
  }

  return output
}
